import { ordersInProgress, formatMoney } from "@/mocks/managerWorkspace";

export default function OrdersInProgressWidget() {
  const totalAmount = ordersInProgress.reduce((sum, o) => sum + o.amount, 0);
  const totalOrders = ordersInProgress.length;
  const visibleOrders = ordersInProgress.slice(0, 6);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-file-list-2-line text-[12px] text-[#D97706]"></i>
          <span className="text-[11px] font-semibold text-[#D97706]">Заказы в работе</span>
          <span className="text-[10px] text-[#666666]">({totalOrders})</span>
        </div>
        <span className="text-[10px] font-semibold text-[#D97706]">{formatMoney(totalAmount)}</span>
      </div>
      <div className="flex-1 overflow-y-auto">
        <table className="w-full text-[10px]">
          <thead className="bg-[#FFF9E6] border-b border-[#D5CA8A] sticky top-0">
            <tr className="text-[#666666]">
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Заказ</th>
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Клиент</th>
              <th className="text-right px-2 py-1.5 font-medium whitespace-nowrap">Сумма</th>
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Статус</th>
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Дата</th>
            </tr>
          </thead>
          <tbody>
            {visibleOrders.map((order, i) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/20 transition-colors cursor-pointer">
                <td className="px-2 py-1.5 text-[#666666] whitespace-nowrap">{order.id}</td>
                <td className="px-2 py-1.5 text-[#2D2D2D] font-medium whitespace-nowrap">{order.client}</td>
                <td className="px-2 py-1.5 text-right font-semibold text-[#2D2D2D] whitespace-nowrap">{formatMoney(order.amount)}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium whitespace-nowrap ${order.statusColor}`}>{order.status}</span>
                </td>
                <td className="px-2 py-1.5 text-[#666666] whitespace-nowrap">{order.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все заказы
        </button>
      </div>
    </div>
  );
}